<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">All Job Seeker</h3>
      </div>
      <div class="page-header-end">
        <div class="button-group">
          <button @click="exportJobSeeker()" :class="['button small primary', { 'is-loading': isLoading }]">
            <i class="fad fa-file-excel"></i>Export Job Seeker
          </button>
        </div>
      </div>
    </div>
    <div class="tabs-container">
      <div class="tabs">
        <div class="tabs-start">
          <router-link :to="{
            query: {
              type: 'Approved',
              p: $route.query.p,
              q: $route.query.q,
              s: $route.query.s,
              jobLevelId: $route.query.jobLevelId,
              skillTagId: $route.query.skillTagId,
              jobFunctionId: $route.query.jobFunctionId
            },
          }" class="tab">Approved</router-link>
          <router-link :to="{
            query: {
              type: 'Pending',
              p: $route.query.p,
              q: $route.query.q,
              s: $route.query.s,
              jobLevelId: $route.query.jobLevelId,
              skillTagId: $route.query.skillTagId,
              jobFunctionId: $route.query.jobFunctionId
            },
          }" class="tab">Pending</router-link>
          <router-link :to="{
            query: {
              type: 'notVerified',
              p: $route.query.p,
              q: $route.query.q,
              s: $route.query.s,
              jobLevelId: $route.query.jobLevelId,
              skillTagId: $route.query.skillTagId,
              jobFunctionId: $route.query.jobFunctionId
            },
          }" class="tab">Not verify OTP</router-link>
          <router-link :to="{
            query: {
              type: 'Rejected',
              p: $route.query.p,
              q: $route.query.q,
              s: $route.query.s,
              jobLevelId: $route.query.jobLevelId,
              skillTagId: $route.query.skillTagId,
              jobFunctionId: $route.query.jobFunctionId
            },
          }" class="tab">Rejected</router-link>
        </div>
        <div class="tabs-end">
          <input type="text" class="input" v-model="search" placeholder="Name / Email / Mobile" required />
        </div>
      </div>
    </div>
    <div class="filter">
      <div class="grids is-3-desktop gap-10-desktop">
        <NormalSelect v-model="jobLevelId" :info="jobLevelInfo" :name="selectName.jobLevel" />
        <NormalSelect v-model="skillTagId" :info="skillTagInfo" :name="selectName.skillTag" />
        <selctJobFunction v-model="jobFunctionId" :updateText="jobFunctions" />
      </div>
    </div>
    <div class="page-content">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { apolloClient } from "@/services/apollo-client";
import { REUSE } from "@/graphql/manage/query";
import NormalSelect from "../components/others/normalSelect.vue";
import selctJobFunction from "@/components/others/selectJobFunction";
export default {
  components: { NormalSelect, selctJobFunction },
  data: () => ({
    selectName: {
      jobLevel: 'Job Level',
      skillTag: 'Skill Tag'
    },
    search: "",
    type: "Approved",
    isLoading: false,
    jobLevelInfo: [],
    skillTagInfo: [],
    jobFunctions: [],

    jobLevelId: [],
    skillTagId: [],
    jobFunctionId: []
  }),
  created() {
    this.isSkillTag()
    this.isJobLevel()
  },
  watch: {
    search(val) {
      this.$router.push({ query: { ...this.$route.query, s: val } });
    },
    jobLevelId: {
      handler(value) {
        if (value.length) {
          this.$router.push({
            query: {
              ...this.$route.query,
              jobLevelId: value
            }
          }).catch(() => { })
        } else {
          this.$router.push({
            query: {
              ...this.$route.query,
              jobLevelId: value
            }
          }).catch(() => { })
        }
      }, immediate: true
    },
    skillTagId: {
      handler(value) {
        if (value.length) {
          this.$router.push({
            query: {
              ...this.$route.query,
              skillTagId: value
            }
          }).catch(() => { })
        } else {
          this.$router.push({
            query: {
              ...this.$route.query,
              skillTagId: value
            }
          }).catch(() => { })
        }
      }, immediate: true
    },
    jobFunctionId: {
      handler(value) {
        if (value.length) {
          const val = value.map((i) => i._id)
          this.$router.push({
            query: {
              ...this.$route.query,
              jobFunctionId: val
            }
          }).catch(() => { })
        } else {
          this.$router.push({
            query: {
              ...this.$route.query,
              jobFunctionId: value
            }
          }).catch(() => { })
        }
      }, immediate: true
    },
  },
  methods: {
    async exportJobSeeker() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("loading");
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/export-seekers`,
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Job-Seeker-List.xlsx");
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
        await this.$store.dispatch("completed");
      } catch (err) {
        await this.$store.dispatch("error");
        throw new Error(err);
      }
    },
    async isJobLevel() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "JobLevel",
        }
      })
      this.jobLevelInfo = res.data.getReuses;
    },
    async isSkillTag() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "SkillTag",
        },
      });
      this.skillTagInfo = res.data.getReuses;
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  .page-header {
    padding: 10px 20px;
    margin-bottom: 0;
    // border-bottom: 1px solid var(--border-color);
    color: var(--text-color);
  }

  .page-content {
    padding: 20px;

    .tabs {
      margin-top: 0 !important;
    }
  }
}

.filter {
  padding: 10px 20px;
  border-bottom: 1px solid var(--border-color);

  ul {
    padding: 0;
    margin: 0;

    li {
      list-style-type: none;
    }
  }
}
</style>
